import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { ContratoService, EmpenhoService, LicitacaoService, LiquidacaoService, PagamentoService } from 'administrativo-lib';
import { BaseResourceListComponent, Coluna, Filtro, FuncaoService, Licitacao, LicitacaoAudesp, LoginContabil, TipoArquivoFase4 } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { LicitacaoAudespService } from '../service/licitacao-audesp.service';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-list',
  templateUrl: './licitacao-audesp-list.component.html'
})
export class LicitacaoAudespListComponent extends BaseResourceListComponent<any, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public listaTipoFiltro: { id: TipoArquivoFase4 | '*' | '_', nome: string }[];
  public tipoFiltro: TipoArquivoFase4 | '*';
  public filtroData: Date[];
  public apenasNaoExportados: boolean = false;
  public marcado: boolean = false;
  public listaAudesp: LicitacaoAudesp[];
  public arquivosValidos: boolean = false;
  public itemInvalido: LicitacaoAudesp;

  public datepipe: DatePipe;

  public mensagemXML: string[];
  public xmlInvalido: string;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private funcaoService: FuncaoService,
    private licitacaoService: LicitacaoService,
    private contratoService: ContratoService,
    private empenhoService: EmpenhoService,
    private liquidacaoService: LiquidacaoService,
    private pagamentoService: PagamentoService,
    private audespService: LicitacaoAudespService) {
    super(undefined, injector);
    this.datepipe = new DatePipe('pt');
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    if (this.tipoFiltro === '*') {
      return 'licitacao.modalidade';
    } else if (this.tipoFiltro === 'LIC_REG_SIM' || this.tipoFiltro === 'LIC_REG_NAO1' || this.tipoFiltro === 'LIC_REG_NAO2' || this.tipoFiltro === 'LIC_REG_NAO3') {
      return 'modalidade,licitacao_audesp';
    } else if (this.tipoFiltro === 'AJUSTE_CONTRATO' || this.tipoFiltro === 'TERMO_ADITIVO') {
      return 'favorecido,licitacao.licitacao_audesp,licitacao_audesp'
    } else if (this.tipoFiltro === 'EMPENHO') {
      return 'favorecido,ficha.recurso,contrato.licitacao_audesp,licitacao_audesp'
    } else if (this.tipoFiltro === 'EXIGENCIA_OBRAS') {
      return 'licitacao_audesp,licitacao.modalidade,licitacao.licitacao_audesp,licitacao_audesp_obra'
    } else if (this.tipoFiltro === 'EXECUCAO') {
      return 'favorecido,contrato.licitacao_audesp,contrato.licitacao.licitacao_audesp,licitacao_audesp_execucao'
    } else if (this.tipoFiltro === 'DOC_FISCAL') {
      return 'empenho.licitacao_audesp_execucao.parente,licitacao_audesp'
    } else if (this.tipoFiltro === 'PAGAMENTO') {
      return 'liquidacao.empenho,liquidacao.licitacao_audesp,licitacao_audesp'
    } else {
      toastr.error(`Tipo de consulta não disponível (${this.tipoFiltro})`);
    }
    return '';
  }

  protected condicoesGrid(): {} {
    if (this.tipoFiltro === '*') {
      return {
        'licitacao.orgao_id': this.login.orgao.id,
        'tipo$like': 'LIC_REG_%'
      };
    } else if (this.tipoFiltro === 'LIC_REG_SIM' || this.tipoFiltro === 'LIC_REG_NAO1' || this.tipoFiltro === 'LIC_REG_NAO2' || this.tipoFiltro === 'LIC_REG_NAO3') {
      const retorno = { orgao_id: this.login.orgao.id, 'OR': `licitacao_audesp.id$null,licitacao_audesp.tipo=${this.tipoFiltro}` };

      if (this.tipoFiltro === 'LIC_REG_NAO1') retorno['modalidade.codigo$not_in'] = '5,6';
      else if (this.tipoFiltro === 'LIC_REG_NAO3') retorno['modalidade.codigo$in'] = '5,6';

      if (this.filtroData?.length === 1) {
        retorno['data_homologacao'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_homologacao$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_homologacao$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      return retorno;
    } else if (this.tipoFiltro === 'AJUSTE_CONTRATO' || this.tipoFiltro === 'TERMO_ADITIVO') {
      const retorno = { orgao_id: this.login.orgao.id, 'OR': `licitacao_audesp.id$null,licitacao_audesp.tipo=${this.tipoFiltro}`, 'licitacao.licitacao_audesp.armazenado': true };
      if (this.filtroData?.length === 1) {
        retorno['data_inicio'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_inicio$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_inicio$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      if (this.tipoFiltro === 'AJUSTE_CONTRATO')
        retorno['OR'] = 'aditivo$null,aditivo=0'
      else
        retorno['aditivo$gt'] = 0
      return retorno;
    } else if (this.tipoFiltro === 'EMPENHO') {
      const retorno = { orgao_id: this.login.orgao.id, exercicio_id: this.login.exercicio.id, 'contrato.licitacao_audesp_id$not_null': undefined };
      if (this.filtroData?.length === 1) {
        retorno['data_empenho'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_empenho$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_empenho$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      return retorno;
    } else if (this.tipoFiltro === 'EXIGENCIA_OBRAS') {
      const retorno = { orgao_id: this.login.orgao.id, 'licitacao_audesp.armazenado': true };
      if (this.filtroData?.length === 1) {
        retorno['data_empenho'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_empenho$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_empenho$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      return retorno;
    } else if (this.tipoFiltro === 'EXECUCAO') {
      const retorno = { orgao_id: this.login.orgao.id, exercicio_id: this.login.exercicio.id, 'contrato.licitacao_audesp.armazenado': true };
      if (this.filtroData?.length === 1) {
        retorno['data_empenho'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_empenho$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_empenho$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      return retorno;
    } else if (this.tipoFiltro === 'DOC_FISCAL') {
      const retorno = { orgao_id: this.login.orgao.id, exercicio_id: this.login.exercicio.id, 'empenho.licitacao_audesp_execucao_id$not_null': undefined };
      if (this.filtroData?.length === 1) {
        retorno['data_liquidacao'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_liquidacao$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_liquidacao$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      return retorno;
    } else if (this.tipoFiltro === 'PAGAMENTO') {
      const retorno = { orgao_id: this.login.orgao.id, exercicio_id: this.login.exercicio.id, 'liquidacao.licitacao_audesp_id$not_null': undefined };
      if (this.filtroData?.length === 1) {
        retorno['data_pagamento'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
      } else if (this.filtroData?.length === 2) {
        retorno['data_pagamento$ge'] = this.datepipe.transform(this.filtroData[0], 'yyyy-MM-dd');
        retorno['data_pagamento$le'] = this.datepipe.transform(this.filtroData[1], 'yyyy-MM-dd');
      }
      return retorno;
    } else {
      toastr.error(`Tipo de consulta não disponível (${this.tipoFiltro})`);
    }
    return {};
  }

  protected ordenacaoGrid(): string[] {
    if (this.tipoFiltro === '*') {
      return ['codigo$DESC'];
    } else if (this.tipoFiltro === 'LIC_REG_SIM' || this.tipoFiltro === 'LIC_REG_NAO1' || this.tipoFiltro === 'LIC_REG_NAO2' || this.tipoFiltro === 'LIC_REG_NAO3') {
      return ['data_abertura$DESC', 'numero$DESC'];
    } else if (this.tipoFiltro === 'AJUSTE_CONTRATO' || this.tipoFiltro === 'TERMO_ADITIVO') {
      return ['data_inicio$DESC'];
    } else if (this.tipoFiltro === 'EMPENHO') {
      return ['numero$DESC', 'data_empenho$DESC', 'id$DESC'];
    } else if (this.tipoFiltro === 'EXIGENCIA_OBRAS') {
      return ['licitacao.data_abertura$DESC', 'licitacao.numero$DESC'];
    } else if (this.tipoFiltro === 'EXECUCAO') {
      return ['numero$DESC', 'data_empenho$DESC', 'id$DESC'];
    } else if (this.tipoFiltro === 'DOC_FISCAL') {
      return ['data_liquidacao$DESC', 'id$DESC'];
    } else if (this.tipoFiltro === 'PAGAMENTO') {
      return ['data_pagamento$DESC', 'id$DESC'];
    } else {
      toastr.error(`Tipo de consulta não disponível (${this.tipoFiltro})`);
    }
  }

  protected filtrosGrid(): Filtro {
    if (this.tipoFiltro === '*') {
      return {
        number: ['codigo', 'licitacao.numero', 'licitacao.processo', 'licitacao.valor_estimado', 'licitacao.valor_licitado'],
        text: ['tipo', 'licitacao.numero', 'licitacao.processo', 'licitacao.modalidade.nome', 'licitacao.situacao', 'licitacao.objeto'],
      };
    } else if (this.tipoFiltro === 'LIC_REG_SIM' || this.tipoFiltro === 'LIC_REG_NAO1' || this.tipoFiltro === 'LIC_REG_NAO2' || this.tipoFiltro === 'LIC_REG_NAO3') {
      return {
        number: ['licitacao_audesp.codigo', 'numero', 'processo', 'valor_estimado', 'valor_licitado'],
        text: ['numero', 'processo', 'modalidade.nome'],
      }
    } else if (this.tipoFiltro === 'AJUSTE_CONTRATO' || this.tipoFiltro === 'TERMO_ADITIVO') {
      return {
        number: ['licitacao_audesp.codigo', 'numero', 'aditivo', 'valor_contrato'],
        text: ['favorecido.nome'],
      }
    } else if (this.tipoFiltro === 'EMPENHO') {
      return {
        number: ['licitacao_audesp.codigo', 'numero', 'valor_empenho', 'contrato.numero'],
        text: ['favorecido.nome', 'contrato.numero']
      }
    } else if (this.tipoFiltro === 'EXIGENCIA_OBRAS') {
      return {
        number: ['licitacao_audesp_obra.codigo', 'numero', 'licitacao.numero', 'licitacao.processo'],
        text: ['licitacao.modalidade.nome']
      }
    } else if (this.tipoFiltro === 'EXECUCAO') {
      return {
        number: ['licitacao_audesp_execucao.codigo', 'numero', 'valor_empenho'],
        text: ['favorecido.nome']
      }
    } else if (this.tipoFiltro === 'DOC_FISCAL') {
      return {
        number: ['licitacao_audesp.codigo', 'documento', 'empenho.numero', 'valor_liquidado'],
      }
    } else if (this.tipoFiltro === 'PAGAMENTO') {
      return {
        number: ['licitacao_audesp.codigo', 'documento', 'liquidacao.empenho.numero', 'valor_pago'],
      }
    } else {
      toastr.error(`Tipo de consulta não disponível (${this.tipoFiltro})`);
    }
  }

  public beforeInit(): void {
    const tipoFiltroSessao = sessionStorage.getItem('/licitacoes_audesp_tipoFiltro');
    if (!tipoFiltroSessao || tipoFiltroSessao === '*')
      this.tipoFiltro = '*'
    else
      this.tipoFiltro = tipoFiltroSessao as TipoArquivoFase4
  }

  protected afterInit(): void {
    this.listaTipoFiltro = [
      { id: '*', nome: 'Licitações iniciadas' },
      { id: '_', nome: '──────────────────────────────' },
      { id: 'LIC_REG_SIM', nome: 'Registros de Preços Sim' },
      { id: 'LIC_REG_NAO1', nome: 'Registros de Preços Não' },
      { id: 'LIC_REG_NAO2', nome: 'Registros de Preços Não (Internacional)' },
      { id: 'LIC_REG_NAO3', nome: 'Registros de Preços Não (Contratação Direta)' },
      { id: '_', nome: '──────────────────────────────' },
      { id: 'AJUSTE_CONTRATO', nome: 'Ajustes de Contratos' },
      { id: 'AJUSTE_EMPENHO', nome: 'Ajustes de Notas de Empenho' },
      { id: '_', nome: '──────────────────────────────' },
      { id: 'EXECUCAO', nome: 'Execuções' },
      { id: 'DOC_FISCAL', nome: 'Documentos Fiscais' },
      { id: 'PAGAMENTO', nome: 'Pagamentos' },
      { id: '_', nome: '──────────────────────────────' },
      { id: 'TERMO_ADITIVO', nome: 'Termos Aditivos' },
      { id: 'EMPENHO', nome: 'Empenhos' },
      { id: 'EXIGENCIA_OBRAS', nome: 'Exigências de Obras' },
    ]
    this.trocarTipo();
  }

  protected acaoRemover(model: LicitacaoAudesp): Observable<LicitacaoAudesp> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return null;
  }

  public iniciarFiltros() {
    this.filtro = '';
    // this.filtroData = [this.funcaoService.adicionarMes(-1, new Date()), new Date()]
    this.apenasNaoExportados = false;
  }

  public trocarTipo() {
    this.lista = [];
    if (this.tipoFiltro === '*') {
      this.baseResourceService = this.audespService;
    } else if (this.tipoFiltro === 'LIC_REG_SIM' || this.tipoFiltro === 'LIC_REG_NAO1' || this.tipoFiltro === 'LIC_REG_NAO2' || this.tipoFiltro === 'LIC_REG_NAO3') {
      this.baseResourceService = this.licitacaoService;
    } else if (this.tipoFiltro === 'AJUSTE_CONTRATO' || this.tipoFiltro === 'TERMO_ADITIVO' || this.tipoFiltro === 'EXIGENCIA_OBRAS') {
      this.baseResourceService = this.contratoService;
    } else if (this.tipoFiltro === 'EMPENHO' || this.tipoFiltro === 'EXECUCAO') {
      this.baseResourceService = this.empenhoService;
    } else if (this.tipoFiltro === 'DOC_FISCAL') {
      this.baseResourceService = this.liquidacaoService;
    } else if (this.tipoFiltro === 'PAGAMENTO') {
      this.baseResourceService = this.pagamentoService;
    } else {
      toastr.error(`Tipo de consulta não disponível (${this.tipoFiltro})`);
      return
    }
    this.atualizarListagem();
  }

  public atualizarListagem() {
    this.onClick(this.filtro);
    sessionStorage.setItem(`/licitacoes_audesp_tipoFiltro`, this.tipoFiltro);
  }

  public toggleSelecionado() {
    // marcado === false marcado
    // marcado === true desmarcado
    if (this.tipoFiltro === 'EMPENHO')
      this.lista.filter(l => l.contrato?.licitacao_audesp).forEach(l => l.selecionado = !this.marcado)
    else if (this.tipoFiltro === 'EXIGENCIA_OBRAS')
      this.lista.filter(l => l.licitacao_audesp_obra).forEach(l => l.selecionado = !this.marcado)
    else if (this.tipoFiltro === 'EXECUCAO')
      this.lista.filter(l => l.licitacao_audesp_execucao).forEach(l => l.selecionado = !this.marcado)
    else if (this.tipoFiltro === 'PAGAMENTO')
      this.lista.filter(l => l.liquidacao?.licitacao_audesp).forEach(l => l.selecionado = !this.marcado)
    else
      this.lista.filter(l => l.licitacao_audesp).forEach(l => l.selecionado = !this.marcado)
  }

  public iniciarPacote() {
    this.listaAudesp = [];
    new Promise((resolve, reject) => {
      if (this.tipoFiltro === 'EMPENHO') {
        this.audespService.gerarEmpenhos(this.lista.filter(l => l.contrato?.licitacao_audesp && l.selecionado).map(a => a.id)).pipe(takeUntil(this.unsubscribe))
          .subscribe((retorno) => { this.listaAudesp = retorno; resolve(true); })
      } else if (this.tipoFiltro === 'EXIGENCIA_OBRAS') {
        this.lista.filter(l => l.licitacao_audesp_obra && l.selecionado).forEach(l => this.listaAudesp.push(l.licitacao_audesp_obra))
        resolve(true)
      } else if (this.tipoFiltro === 'EXECUCAO') {
        this.lista.filter(l => l.licitacao_audesp_execucao && l.selecionado).forEach(l => this.listaAudesp.push(l.licitacao_audesp_execucao))
        resolve(true)
      } else if (this.tipoFiltro === 'PAGAMENTO') {
        this.audespService.gerarPagamentos(this.lista.filter(l => l.liquidacao?.licitacao_audesp && l.selecionado).map(a => a.id)).pipe(takeUntil(this.unsubscribe))
          .subscribe((retorno) => { this.listaAudesp = retorno; resolve(true); })
      } else {
        (this.lista as Licitacao[]).filter(l => l.licitacao_audesp && l.selecionado).forEach(l => {
          l.licitacao_audesp.licitacao = Object.assign({}, l);
          delete l.licitacao_audesp.licitacao.licitacao_audesp;
          this.listaAudesp.push(l.licitacao_audesp)
        })
        resolve(true)
      }
    }).then(() => {
      if (this.listaAudesp.length === 0) {
        toastr.warning('Nenhum registro foi selecionado para geração do pacote');
        return;
      }
      $('#dialogFase4Pacote').modal('show');
      this.arquivosValidos = false;
    });
  }

  public validarRegistros() {
    this.arquivosValidos = false;

    let validados = 0;
    this.listaAudesp.forEach(a => {
      a.valido = undefined;
      a.mensagemXML = undefined;
      this.audespService.validarXML(a.id).toPromise().catch(error => {
        a.valido = false;
        a.mensagemXML = String(error.error.payload).split('\n');
        if (a.mensagemXML.find(str => str.startsWith('ARQUIVO_XML:'))) {
          a.mensagemXML.splice(a.mensagemXML.indexOf(a.mensagemXML.find(str => str.startsWith('ARQUIVO_XML:'))), 1)[0];
        }
      }).finally(() => {
        if (a.valido === undefined) a.valido = true;
        validados++;
        if (validados === this.listaAudesp.length)
          this.arquivosValidos = new Boolean(!this.listaAudesp.find(a => !a.valido)).valueOf()
      })
    })
  }

  public visualizarInconsistencias(item: LicitacaoAudesp) {
    if (!item || item.valido || item.mensagemXML?.length === 0) return;
    this.itemInvalido = item;
    $('#dialogMensagensXML').modal('show');
  }

  public gerarPacotes() {
    this.audespService.gerarPacote(this.listaAudesp.map(a => a.id)).pipe(takeUntil(this.unsubscribe))
      .subscribe((retorno) => {
        if (!retorno) return;
        retorno.forEach(arquivo => {
          let nomeArquivo = '';
          if (arquivo.pacote)
            nomeArquivo = `${arquivo.pacote.id}_${arquivo.pacote.tipo}_${this.funcaoService.converteDataBR(new Date()).split('/').join('')}`
          else
            nomeArquivo = `${this.funcaoService.removerPontos(this.listaAudesp[0].licitacao.numero)}_${this.listaAudesp[0].tipo}`

          const element = document.createElement('a');
          element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(this.funcaoService.formatXml(arquivo.xml)));
          element.setAttribute('download', `${nomeArquivo}.xml`);
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          this.mensagemXML = undefined;
          this.xmlInvalido = undefined;
          $('#dialogFase4Pacote').modal('hide');
        })
      }, error => {
        this.mensagemXML = String(error.error.payload).split('\n');
        if (this.mensagemXML.find(str => str.startsWith('ARQUIVO_XML:'))) {
          this.xmlInvalido = this.mensagemXML.splice(this.mensagemXML.indexOf(this.mensagemXML.find(str => str.startsWith('ARQUIVO_XML:'))), 1)[0];
          this.xmlInvalido = this.xmlInvalido.substring('ARQUIVO_XML:'.length, this.xmlInvalido.length);
        }
        $('#dialogMensagensXMLPacote').modal('show');
      });
  }

  public baixarXMLInvalido() {
    if (!this.xmlInvalido) return;
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(this.funcaoService.formatXml(this.xmlInvalido)));
    element.setAttribute('download', `PACOTE_INVALIDO.xml`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
